import { combineReducers } from "redux";

import PartnerReducer from "./PartnerReducer";
import CartReducer from "./CartReducer";
import BillingReducer from "./BillingReducer";

export default combineReducers({
	PartnerReducer,
	CartReducer,
	BillingReducer
});
